module.exports = __webpack_public_path__ + "static/media/194.14460f7a.webp";